import React, { useState, useEffect } from 'react';
import { useTournament } from 'context/TournamentContext';

import {
  BannerImg,
  Wrap,
} from './styled';
import { LANDING } from 'constants/routes';

const Banner = () => {
  const { tournamentDetails } = useTournament();
  const tournamentId = tournamentDetails?.data?.id;
  const [bannerClass, setBannerClass] = useState(null);
  const [bannerLink, setBannerLink] = useState(LANDING);

  useEffect(() => {
    if (tournamentId === 82 ) {
      setBannerClass('banner_casper')
      setBannerLink('https://casper.network/en-us/')
    }
    if (tournamentId === 85 || tournamentId === 168 || tournamentId === 237 || tournamentId === 239 || tournamentId === 272 || tournamentId === 273 || tournamentId === 295 || tournamentId === 301 || tournamentId === 342) {
      setBannerClass('banner_bitomat')
      setBannerLink('https://www.bitomat.com/')
    }
    if (tournamentId === 87 ) {
      setBannerClass('banner_bitget')
      setBannerLink('https://www.bitget.com/')
    }
    if (tournamentId === 120 ) {
      setBannerClass('banner_KryptoSilesia')
      setBannerLink('')
    }
    if (tournamentId === 122 ) {
      setBannerClass('banner_BL')
      setBannerLink('https://blackfort.exchange/')
    }
    if (tournamentId === 125 ) {
      setBannerClass('banner_coinex')
      setBannerLink('https://www.coinex.com/s/4JHE')
    }
    if (tournamentId === 124 ) {
      setBannerClass('banner_Time3xBanner')
      setBannerLink(null)
    }
    if (tournamentId === 165 ) {
      setBannerClass('banner_Time2xBanner')
      setBannerLink(null)
    }
    if (tournamentId === 229 ) {
      setBannerClass('banner_ETHdam')
      setBannerLink('https://www.metrontrading.com/')
    }
    if (tournamentId === 230 ) {
      setBannerClass('banner_BF25')
      setBannerLink('https://listing.help')
    }
    if (tournamentId === 299 ) {
      setBannerClass('banner_kucoin_eu')
      setBannerLink('https://www.kucoin.com/en-eu')
    }
    if (tournamentId === 341 ) {
      setBannerClass('banner_gomining')
      setBannerLink('https://gomining.com')
    }
  }, [tournamentDetails?.data?.id, tournamentId]);

  return (
    <Wrap>
      <p className="TitleBanner">Sponsored by:</p>
      <a href={bannerLink} target="_blank" rel="noopener noreferrer">
        <BannerImg className={bannerClass}></BannerImg>
      </a>
    </Wrap>
  );
};

export default Banner;
